import { render, staticRenderFns } from "./oaWorkplace.vue?vue&type=template&id=38004aa6&scoped=true"
import script from "./oaWorkplace.vue?vue&type=script&lang=js"
export * from "./oaWorkplace.vue?vue&type=script&lang=js"
import style0 from "./oaWorkplace.vue?vue&type=style&index=0&id=38004aa6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38004aa6",
  null
  
)

export default component.exports